module.exports = __webpack_public_path__ + "static/media/fi-rr-duplicate-black.a2bfe73c.svg";